import { render, staticRenderFns } from "./AuthForgotPasswordForm.vue?vue&type=template&id=999f3896"
import script from "./AuthForgotPasswordForm.vue?vue&type=script&lang=js"
export * from "./AuthForgotPasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('999f3896')) {
      api.createRecord('999f3896', component.options)
    } else {
      api.reload('999f3896', component.options)
    }
    module.hot.accept("./AuthForgotPasswordForm.vue?vue&type=template&id=999f3896", function () {
      api.rerender('999f3896', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AuthForgotPasswordForm.vue"
export default component.exports